import { useQuery } from '@tanstack/react-query';
import { BotsActivityStatusResponse } from '../../../types/bots-activity/BotsActivityStatusResponse';
import { getStatus } from '../../../services/bots-activity/BotsActivityService';
import { GET_BOTS_ACTIVITY_STATUS } from '../../query/bots-activity/keys';

export const useGetBotsActivityStatus = (
  projectId: number | null,
  range: string = '7d'
) => {
  const queryEnabled = !!projectId;

  const { data, isLoading, isError, refetch } = useQuery<BotsActivityStatusResponse>({
    queryKey: [GET_BOTS_ACTIVITY_STATUS, projectId, range],
    queryFn: () => getStatus(projectId!, range),
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 10,
    refetchOnWindowFocus: false,
    enabled: queryEnabled,
    // Poll every 20 seconds while backfill is in progress (§17.7)
    refetchInterval: (query) => {
      const statusData = query.state.data as BotsActivityStatusResponse | undefined;
      return statusData?.backfillInProgress ? 1000 * 20 : false;
    },
  });

  return {
    data,
    isLoading: queryEnabled ? isLoading : false,
    isError,
    refetch,
  };
};
